import React from 'react';

const FullPageLoader = () => {
  return (
    <div
      className="flex h-dvh w-screen items-center justify-center bg-white"
      role="status"
      aria-label="Loading"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
};

export { FullPageLoader };
